import React, { Component } from "react";
class TableSelect extends React.Component
{
    
    constructor(props)
    {
        super(props);
        this.state =
        {
            value: this.props.value,
            errmsg: this.props.errmsg,
            liste: [],
        }
        this.retourapi = this.retourapi.bind(this);
    }

    componentDidMount()
    {
        this.props.api (this.retourapi);
    }

    componentMustRefresh()
    {
        this.props.api (this.retourapi);
    }


    retourapi (data)
    {
        
        var newvalue = this.state.value;
        if (this.state.value != 0)
        {
            var found = false;
            for (var i=0; i<data.length; i++)
            {
                if (data[i][this.props.tableid] == this.state.value)
                {
                    found = true;
                    break;
                }
            }
            if (!found)  newvalue = 0;
        }
        this.setState ({value: newvalue, liste: data})

    }

    setErrorMsg(msg)
    {
        this.setState({errmsg:msg});
    }

    componentDidUpdate()
    {
        this.props.onChange();
    }

    setValue(text)
    {
        this.setState({value:text})
    }


    getValue()
    {
        return this.state.value;
    }

    render()
    {
        var msg="";
        if (this.state.errmsg != "")
        {
            msg=(
                <span style={{borderRadius:"3px",marginLeft:"12px",color:"white", borderStyle:"solid", borderColor:"red", borderWidth:"1px"}}
                    >
                &nbsp;&nbsp;{this.state.errmsg}&nbsp;&nbsp;
                </span>
            )
        }



        return (<>
            <div className = "dialog-Input-Title">
                {this.props.title}{msg}
            </div>

            
            <select className="dialog-Input-Datas" 
                id={"select"+this.props.tableid} 
                value = {this.state.value}
                style = {{width: this.props.width, textAlign: "left"}}
                disabled={this.props.disabled}
                onChange={e => this.setState({value:e.target.value})}
                >
                <option value={0} key={-1}>
                    {this.props.unselect}
                </option>

                {this.state.liste.map((oneoption, index) => (
                    <option key={index} value={oneoption[this.props.tableid]}>
                     {oneoption[this.props.tablename]}

                    </option>
                    ))}


            </select>


            
        </>);
    
    }

}
TableSelect.defaultProps = 
{
    autoFocus: false,
    readOnly: false,
    disabled: false,
    errmsg: "",
}

export default TableSelect